// Pasul 33: vitrina de 3 lucrari de pe pagina membrului, intre CV scurt si CV complet.
// Lucrarile vin din API (`lucrariAleatorii`, aceleasi toata ziua), cu varianta de imagine a
// nivelului lor; la lucrarile teaser (blurate) apare o nota spre expozitia care le dezvaluie.
import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Box, Link, Typography} from '@mui/material';
import {GalleryImage, photoUrl} from './GalleryImage';
import {formatData} from './dateExpozitie';
import {MENTIUNE_DETALIU, imagineCard} from './GrilaLucrari';

export const notaTeaser = (lucrari, expozitie) => {
    if (!lucrari?.some((l) => l.nivel === 'teaser')) return null;
    return expozitie ? {expozitie} : {faraExpozitie: true};
};

const VitrinaLucrari = ({lucrari, expozitieViitoare, nume, linkLucrare, total, onToate, afiseazaNota = true}) => {
    if (!lucrari?.length) return null;
    const nota = notaTeaser(lucrari, expozitieViitoare);
    return (
        <Box component="section" aria-label="Din lucrările artistului" sx={{clear: 'both', mb: 3}}>
            <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: {xs: 1, sm: 2}}}>
                {lucrari.map((l) => {
                    // 44.4: fragmentul clar ales de artist, cu eticheta lui; altfel varianta nivelului.
                    const imagine = imagineCard(l);
                    return <Box key={l.id} component={RouterLink} to={linkLucrare(l)} title={l.nume}
                         sx={{display: 'block', position: 'relative', aspectRatio: '1 / 1', overflow: 'hidden', borderRadius: 1,
                              background: 'var(--gallery-paper)',
                              '& img': {width: '100%', height: '100%', objectFit: 'cover', display: 'block'}}}>
                        {imagine.src && <GalleryImage src={photoUrl(imagine.src)} alt={imagine.detaliu ? `${l.nume} (${MENTIUNE_DETALIU.toLowerCase()})` : l.nume} loading="lazy" />}
                        {imagine.detaliu && <Typography component="span" variant="caption"
                            sx={{position: 'absolute', left: 4, bottom: 4, px: .75, borderRadius: .5, lineHeight: 1.6,
                                 bgcolor: 'rgba(0,0,0,.6)', color: '#fff', maxWidth: 'calc(100% - 8px)', overflow: 'hidden',
                                 textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{MENTIUNE_DETALIU}</Typography>}
                    </Box>;
                })}
            </Box>
            {afiseazaNota && nota && (
                <Typography variant="body2" color="text.secondary" sx={{mt: 1}} data-testid="nota-teaser">
                    {nota.expozitie ? <>
                        Descoperă lucrările lui {nume} la expoziția{' '}
                        <Link component={RouterLink} to={`/expozitii/${encodeURIComponent(nota.expozitie.slug)}`}>
                            {nota.expozitie.numeExpozitie}
                        </Link>
                        {nota.expozitie.deschidere && <>, din {formatData(nota.expozitie.deschidere)}</>}.
                    </> : 'Lucrările sunt prezentate momentan în previzualizare.'}
                </Typography>
            )}
            {total > lucrari.length && (
                <Link component="button" type="button" variant="body2" onClick={onToate} sx={{mt: 1, display: 'block'}}>
                    Toate lucrările ({total}) ↓
                </Link>
            )}
        </Box>
    );
};

export default VitrinaLucrari;
